export function isClosed(type: string, id: string): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  let result
  try {
    result = window.localStorage.getItem(`${type}_${id}`)
  } catch (error) {}
  return !!result
}

export function setClose(type: string, id: string): void {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem(`${type}_${id}`, '1')
  } catch (err) {}
}
